import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ImageTextBlock from 'components/essentials/ImageTextBlock';
import ContentfulImage from '../ContentfulImage/ContentfulImage';
const BlogCard = t0 => {
  const $ = _c(21);
  const {
    post
  } = t0;
  const image = post.featuredImage ? post.featuredImage.fields.file : "";
  const description = post.featuredImage.fields?.description !== "" ? post.featuredImage.fields?.description : post.featuredImage.fields?.title !== "" ? post.featuredImage.fields?.title : "";
  const t1 = `${post.slug}/`;
  let t2;
  if ($[0] !== image.url) {
    t2 = image.url.replace("downloads.ctfassets.net", "images.ctfassets.net");
    $[0] = image.url;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== description || $[3] !== t2) {
    t3 = <div className="max-h-[370px] overflow-hidden"><ContentfulImage className="w-full" src={t2} alt={description} type="grid" /></div>;
    $[2] = description;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <Link to={t1}>{t3}</Link>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== post.title) {
    t5 = {
      content: post.title
    };
    $[8] = post.title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== post.description) {
    t6 = {
      content: post.description
    };
    $[10] = post.description;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== post.slug) {
    t7 = {
      linkTo: post.slug,
      content: "Read more"
    };
    $[12] = post.slug;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <ImageTextBlock heading={t5} subText={t6} cta={t7} />;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t8) {
    t9 = <div>{t4}{t8}</div>;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default BlogCard;
BlogCard.propTypes = {
  post: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    slug: PropTypes.string,
    featuredImage: PropTypes.shape({
      fields: PropTypes.shape({
        description: PropTypes.string,
        title: PropTypes.string,
        file: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })
  }).isRequired
};